// Multivariate Dependencies
import { useEffect, useState } from 'react';
/**
 * @description Hook to retrieve targeted element bounds
 *
 * @param {MutableRefObject<HTMLElement>} targetedElementRef - targeted element ref
 *
 * @returns {{ x: number, y: number, width: number, height: number }} - targeted element bounds
 */
export var useTargetedElementBounds = function (targetedElementRef) {
    var _a = useState({ x: 0, y: 0, width: 0, height: 0 }), elementBounds = _a[0], setElementBounds = _a[1];
    useEffect(function () {
        if (targetedElementRef === null || targetedElementRef === void 0 ? void 0 : targetedElementRef.current) {
            // this is used to get the targeted element bounding rect values without reflow / layout
            var observer_1 = new IntersectionObserver(function (entries) {
                for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                    var entry = entries_1[_i];
                    var _a = entry.intersectionRect, x = _a.x, y = _a.y, width = _a.width, height = _a.height;
                    setElementBounds({ x: x, y: y, width: width, height: height });
                    observer_1.unobserve(targetedElementRef.current);
                }
            }, { root: null, rootMargin: '0px', threshold: 1.0 });
            observer_1.observe(targetedElementRef.current);
            return function () {
                observer_1.disconnect();
            };
        }
    }, []);
    return elementBounds;
};
//# sourceMappingURL=useTargetedElementBounds.js.map